import React from 'react'
import CareerSlider from './CareerSlider'

const Career = () => {
    return (
        <div>
            <div>
                {/* Hero section start */}
                <section className="_blog_nft_hero_wrapper">
                    <div className="container">
                        <div className="_blog_nft_hero_wrap">
                            <div className="row align-items-center">
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <img src="assets/img/bloghero.png" alt="chobi"className="_blog_nft_hero_img" />
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <div className="_blog_nft_hero_right">
                                        <h2 className="_blog_nft_hero_right_title">Let’s build the future of
                                            digital economies together</h2>
                                        <p className="_blog_nft_hero_right_txt">Not only are we passionate about our work, we enjoy the
                                            people we surround ourselves with. At OpenSea, we build trust, embrace feedback, grow
                                            rapidly, and love our work.</p>
                                        <a href="#0" className="_blog_nft_hero_right_link">view our open possitions</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="_career_persons_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-6 co-12">
                                <div className="_doc_nft_card1">
                                    <div className="_doc_nft_card1_img">
                                        <img src="assets/img/doc-nft-card-img04.png" alt="chobi" className="_doc_nft_card1_img_tag" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6 co-12">
                                <div className="_doc_nft_card1">
                                    <div className="_doc_nft_card1_img">
                                        <img src="assets/img/doc-nft-card-img05.png" alt="chobi" className="_doc_nft_card1_img_tag" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6 co-12">
                                <div className="_doc_nft_card1">
                                    <div className="_doc_nft_card1_img">
                                        <img src="assets/img/doc-nft-card-img06.png" alt="chobi" className="_doc_nft_card1_img_tag" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Hero section ends */}
                {/*about nft wrapper*/}
                <section className="_about_nft_wrapper">
                    <div className="_about_nft_wrap">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12">
                                    <div className="_about_nft_head">
                                        <h3 className="_about_nft_head_txt">Where we come from</h3>
                                        <p className="_about_nft_head_para">Our team has varied
                                            backgrounds from Stanford, UC Berkeley, Georgia Tech,
                                            Waterloo, San Jose State University, DePauw University,
                                            and SUNY schools. We also have team members who pursued
                                            other interests in lieu of a traditional college
                                            education, such as signing a recording deal with
                                            Universal Music Group.
                                        </p>
                                    </div>
                                    <CareerSlider/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*about nft wrapper end*/}
                {/*our values nft wrapper*/}
                <section className="_faq_nft_wrapper">
                    <div className="_faq_nft_wrap">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12">
                                    <div className="_faq_nft_head">
                                        <h3 className="_faq_nft_head_txt">our values</h3>
                                        <p className="_faq_nft_head_para">Our values are at the core of our efforts to build the best
                                            platform for our users
                                        </p>
                                    </div>
                                    <div className="_faq_nft_accord_wrap">
                                        <div className="accordion" id="accordionPanelsStayOpenExample">
                                            <div className="accordion-item _item_space">
                                                <h6 className="accordion-header" id="panelsStayOpen-headingOne">
                                                    <button className="accordion-button _faq_nft_accord_itm_btn" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false" aria-controls="panelsStayOpen-collapseOne">
                                                        cultivate continuous growth
                                                    </button>
                                                </h6>
                                                <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                                                    <div className="accordion-body _faq_nft_accord_itm_cont">
                                                        But I must explain to you how all this mistaken idea of denouncing pleasure
                                                        and praising pain was born and I will give you a complete account of the
                                                        system, and expound the actual teachings of the great explorer of the truth,
                                                        the master-builder of human happiness.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item _item_space">
                                                <h6 className="accordion-header" id="panelsStayOpen-headingTwo">
                                                    <button className="accordion-button collapsed _faq_nft_accord_itm_btn" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="true" aria-controls="panelsStayOpen-collapseTwo">
                                                        what makes all blocks special?
                                                    </button>
                                                </h6>
                                                <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                                                    <div className="accordion-body _faq_nft_accord_itm_cont">
                                                        An NFT is a digital asset stored on the blockchain.
                                                        These assets hold information,
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item _item_space">
                                                <h6 className="accordion-header" id="panelsStayOpen-headingThree">
                                                    <button className="accordion-button collapsed _faq_nft_accord_itm_btn" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="true" aria-controls="panelsStayOpen-collapseThree">
                                                        what does a partnership with allblocks entail?
                                                    </button>
                                                </h6>
                                                <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                                                    <div className="accordion-body _faq_nft_accord_itm_cont">
                                                        An NFT is a digital asset stored on the blockchain.
                                                        These assets hold information,
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item _item_space">
                                                <h6 className="accordion-header" id="panelsStayOpen-headingFour">
                                                    <button className="accordion-button collapsed _faq_nft_accord_itm_btn" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="true" aria-controls="panelsStayOpen-collapseFour">
                                                        what does it cost to partner with oallblocks
                                                    </button>
                                                </h6>
                                                <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFour">
                                                    <div className="accordion-body _faq_nft_accord_itm_cont">
                                                        An NFT is a digital asset stored on the blockchain.
                                                        These assets hold information,
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item _item_space">
                                                <h6 className="accordion-header" id="panelsStayOpen-headingFive">
                                                    <button className="accordion-button collapsed _faq_nft_accord_itm_btn" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="true" aria-controls="panelsStayOpen-collapseFive">
                                                        how do we get started?
                                                    </button>
                                                </h6>
                                                <div id="panelsStayOpen-collapseFive" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFive">
                                                    <div className="accordion-body _faq_nft_accord_itm_cont">
                                                        An NFT is a digital asset stored on the blockchain.
                                                        These assets hold information,
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*our values nft wrapper end*/}
                <section className="_career_persons_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-6 co-12">
                                <div className="_doc_nft_card1">
                                    <div className="_doc_nft_card1_img">
                                        <img src="assets/img/careerperson1.png" alt="chobi" className="_doc_nft_card1_img_tag" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6 co-12">
                                <div className="_doc_nft_card1">
                                    <div className="_doc_nft_card1_img">
                                        <img src="assets/img/careerperson2.png" alt="chobi" className="_doc_nft_card1_img_tag" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6 co-12">
                                <div className="_doc_nft_card1">
                                    <div className="_doc_nft_card1_img">
                                        <img src="assets/img/careerperson3.png" alt="chobi" className="_doc_nft_card1_img_tag" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*feature nft wrapper */}
                <section className="_feature_nft_wrapper">
                    <div className="_feature_nft_wrap">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12">
                                    <div className="_feature_nft_head">
                                        <h3 className="_feature_nft_head_txt">Our Perks</h3>
                                        <p className="_feature_nft_head_para">Hop aboard and view our open positions</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="_feature_nft_card">
                                        <div className="_feature_nft_card_cont">
                                            <h6 className="_feature_nft_card_cont_txt">Interested in joining us?</h6>
                                            <p className="_feature_nft_card_cont_para">Employees are our number-one priority, so we like
                                                to take care of them!</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="_feature_nft_card">
                                        <div className="_feature_nft_card_cont">
                                            <h6 className="_feature_nft_card_cont_txt">Health insurance</h6>
                                            <p className="_feature_nft_card_cont_para">Your wellness is important. We've got you
                                                covered. Take care of yourself to come to work happy and healthy.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="_feature_nft_card">
                                        <div className="_feature_nft_card_cont">
                                            <h6 className="_feature_nft_card_cont_txt">Flexible vacation policy</h6>
                                            <p className="_feature_nft_card_cont_para">Sometimes we all need a break. Take one, take
                                                many. Just come back recharged and inspired.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="_feature_nft_card">
                                        <div className="_feature_nft_card_cont">
                                            <h6 className="_feature_nft_card_cont_txt">Flexible hours</h6>
                                            <p className="_feature_nft_card_cont_para">We know you have personal priorities to take
                                                care of. Take care of them and work on your own hours; we’re flexible.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="_feature_nft_card">
                                        <div className="_feature_nft_card_cont">
                                            <h6 className="_feature_nft_card_cont_txt">Workshops &amp; conferences</h6>
                                            <p className="_feature_nft_card_cont_para">Attend relevant workshops and conferences to grow
                                                and develop. It’s our priority.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="_feature_nft_card">
                                        <div className="_feature_nft_card_cont">
                                            <h6 className="_feature_nft_card_cont_txt">Travel &amp; company retreats</h6>
                                            <p className="_feature_nft_card_cont_para">As an international team, we take the time to
                                                meet up for company retreats.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="_feature_nft_card">
                                        <div className="_feature_nft_card_cont">
                                            <h6 className="_feature_nft_card_cont_txt">Work from home</h6>
                                            <p className="_feature_nft_card_cont_para">Avoid long commutes in and out of the office.
                                                Instead, work in the comfort of your own home and set-up.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="_feature_nft_card">
                                        <div className="_feature_nft_card_cont">
                                            <h6 className="_feature_nft_card_cont_txt">Game nights</h6>
                                            <p className="_feature_nft_card_cont_para">Once a month, we set work aside and play a game
                                                or two to bond as a team.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="_feature_nft_card">
                                        <div className="_feature_nft_card_cont">
                                            <h6 className="_feature_nft_card_cont_txt">Others</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*feature nft wrapper end*/}
                <div className="_reward_nft_btm_wrapper _career">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <h3 className="_reward_nft_stake_box_title">Interested in joining us?</h3>
                                <h6 className="_reward_nft_stake_box_txt">Hop aboard and view our open positions</h6>
                                <div className="_reward_nft_stake_title_btn_wrap">
                                    <a href="#0" className="_reward_nft_stake_title_btn1">see open roles</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Career